export default "__VITE_ASSET___Bq_Tzcn__"